export const qs = (s, o = document) => o.querySelector(s);
export const qsa = (s, o = document) => o.querySelectorAll(s);
